import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className} data-id="element-534" data-mp="3gfnub17ml1au">{children}</div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2,
    margin: '0px 0px -40px 0px'
  }} transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1],
    delay
  }} className={className} data-id="element-535" data-mp="3gijwj1qiac53">
      {children}
    </motion.div>;
}